import React, { useState, useEffect, act } from 'react';

const ActionService = ({ onClose, onConfirm, product, actionType, setEnrollmentAck }) => {

    useEffect(() => {
        // Fetch data if necessary
    }, []);

    const handleConfirm = () => {
        onConfirm(product, actionType);
    };

    const handleClose = () => {
        onClose();
    };

    const handleCheckboxChange = (event) => {
        setEnrollmentAck(event.target.checked); 
    };

    return (
        <div className='popupParent'>
            {/* <h2 className='popupTitle'>TITLE PLACEHOLDER</h2> */}
            <div className='popupBody'>
                <div className='popupTexts'>
                    <div className='popupMainText'>{ actionType === 1 ? 'Confirm Enrollment' : 'Discontinue Service'}</div>
                </div>
                <div>
                <div className='popupSubText'>Click here to read our <a>Terms and Conditions</a></div>
                <label>
                    <input
                        type="checkbox"
                        onChange={handleCheckboxChange}
                    />
                    I confirm that I have read the Terms and Conditions.
                </label>
                </div>
            </div>

            <div className='buttonDiv'>
                <button className='actionButton' onClick={handleConfirm}>CONFIRM</button>
                <button className='delete popDelete' onClick={handleClose}>CLOSE</button>
            </div>
        </div>
    );
};

export default ActionService;